<template>
  <div class="main">
    <div class="title-section">
      <h2>Risultati Finali</h2>
      <h3>Analisi per <span class="company-name">{{ sessionstore.company_name }}</span></h3>
    </div>

    <div class="content">
      <div class="radar-section">
        <RadarGraph ref="spiderGraphRef" :height="500" :width="500" :numberOfDataPoints="3"
          :legend='["Community", "Storytelling", "Experience"]' :dataRatingsColors="[
            'rgba(46, 78, 237, 0.2)',
            'rgba(46, 78, 237, 0.2)',
            'rgba(46, 78, 237, 0.2)'
          ]" :dataRatingsGridColors="[
            'rgba(46, 78, 237, 0.2)',
            'rgba(46, 78, 237, 0.2)',
            'rgba(46, 78, 237, 0.2)'
          ]" />
      </div>

      <div class="scores-section">
        <div class="score-box">
          <div class="score-title">Community</div>
          <div class="score-bar-container">
            <div class="score-bar">
              <div class="score-fill" :style="{ width: sessionstore.communityScore * 10 + '%' }"></div>
            </div>
            <div class="score">{{ sessionstore.communityScore * 10 }} / 100</div>
          </div>
        </div>

        <div class="score-box">
          <div class="score-title">Experience</div>
          <div class="score-bar-container">
            <div class="score-bar">
              <div class="score-fill" :style="{ width: sessionstore.experienceScore * 10 + '%' }"></div>
            </div>
            <div class="score">{{ sessionstore.experienceScore * 10 }} / 100</div>
          </div>
        </div>

        <div class="score-box">
          <div class="score-title">Storytelling</div>
          <div class="score-bar-container">
            <div class="score-bar">
              <div class="score-fill" :style="{ width: sessionstore.storytellingScore * 10 + '%' }"></div>
            </div>
            <div class="score">{{ sessionstore.storytellingScore * 10 }} / 100</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadarGraph from '@/components/widgets/radar.vue';
import { useSessionStore } from '@/stores/sessionStore';
import { onUnmounted } from 'vue';

export default {
  setup() {
    const sessionstore = useSessionStore();

    onUnmounted(() => {
      sessionstore.reset();
    });

    return {
      sessionstore
    };
  },
  name: 'RadarPage',
  components: {
    RadarGraph
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 4rem;
}

.title-section {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto 4rem;
  text-align: left;

  h2 {
    font-size: 3rem;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 2rem;
    font-weight: 500;
    color: #1a1a1a;
  }

  .company-name {
    color: #2e4eed;
  }
}

.content {
  display: flex;
  gap: 6rem;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
}

.radar-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.scores-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3rem;
}

.score-box {
  background: rgba(255, 255, 255, 0.95);
  border: 2px solid #2e4eed;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.score-title {
  font-size: 1.8rem;
  font-weight: 500;
  color: #1a1a1a;
}

.score-bar-container {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.score-bar {
  flex: 1;
  height: 2rem;
  background-color: rgba(46, 78, 237, 0.1);
  border: 2px solid #2e4eed;
  overflow: hidden;
}

.score-fill {
  height: 100%;
  background-color: #2e4eed;
  transition: width 1s ease-in-out;
}

.score {
  font-size: 2.5rem;
  font-weight: 600;
  color: #2e4eed;
  min-width: 100px;
  text-align: right;
}

@media (max-width: 1600px) {
  .content {
    max-width: 1400px;
  }
}

@media (max-width: 1400px) {
  .content {
    max-width: 1200px;
  }
}

@media (max-width: 1024px) {
  .content {
    flex-direction: column;
    align-items: center;
    max-width: 800px;
  }

  .radar-section {
    width: 100%;
    max-width: 600px;
  }

  .scores-section {
    width: 100%;
    max-width: 600px;
  }
}

@media (max-width: 768px) {
  .main {
    padding: 2rem;
  }

  .title-section {
    h2 {
      font-size: 2.5rem;
    }

    h3 {
      font-size: 1.8rem;
    }
  }

  .score-box {
    padding: 1.25rem;
  }

  .score-title {
    font-size: 1.5rem;
  }

  .score {
    font-size: 2rem;
    min-width: 80px;
  }
}
</style>
